export default (function (value) {
  return value.length === 0;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/isEmpty.js
// module id = ./node_modules/redux-actions/es/utils/isEmpty.js
// module chunks = 6 9 11